// Curator accounts: invited by another curator from the dashboard (the
// bootstrap script only makes the first one), and deactivated, never deleted,
// once they have accepted: their name stays on every decision they made.
import { z } from 'zod';

import { displayNameSchema } from './text.ts';

/** How long an invite link works before a curator has to resend it. */
export const CURATOR_INVITE_TTL_DAYS = 7;

export const curatorInviteSchema = z.object({
  fullName: displayNameSchema,
  email: z.string().trim().toLowerCase().pipe(z.email()),
});
export type CuratorInviteInput = z.infer<typeof curatorInviteSchema>;

export type CuratorStatus = 'active' | 'invited' | 'expired' | 'deactivated';

/**
 * Derived, never stored. Deactivation wins over everything; an account that
 * never accepted is `invited` until its link expires.
 */
export function curatorStatus(
  c: { acceptedAt: Date | null; inviteExpiresAt: Date | null; deactivatedAt: Date | null },
  now: Date = new Date(),
): CuratorStatus {
  if (c.deactivatedAt) return 'deactivated';
  if (c.acceptedAt) return 'active';
  return c.inviteExpiresAt && c.inviteExpiresAt > now ? 'invited' : 'expired';
}
